import { render, staticRenderFns } from "./SerieNumeroFormSerieActiva.vue?vue&type=template&id=6ca84e01&"
import script from "./SerieNumeroFormSerieActiva.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormSerieActiva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ca84e01', component.options)
    } else {
      api.reload('6ca84e01', component.options)
    }
    module.hot.accept("./SerieNumeroFormSerieActiva.vue?vue&type=template&id=6ca84e01&", function () {
      api.rerender('6ca84e01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerieActiva/SerieNumeroFormSerieActiva.vue"
export default component.exports